import { ServiceTypes } from 'constants/ServiceTypes';
import React, { useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { UiStore } from 'stores/UiStore';
import { TabsDisplayNames, TabsNames } from 'enums/TabsNames';
import { ITab } from '../../../../../interfaces/ITab';
import { StyledTab, StyledTabs } from './StyledTabs';
import TabLabel from './components/TabLabel';

interface IProps {
  isPlayerTrackingEnabled: boolean;
  isVerified: boolean;
  isPlayerTrackingVerified: boolean;
}

const Tabs: React.FC<IProps> = (props) => {
  const { isPlayerTrackingEnabled, isVerified, isPlayerTrackingVerified } = props;
  const uiStore = useInjection<UiStore>(ServiceTypes.UiStore);
  const [activeTab, setActiveTab] = useState<number>(0);

  const tabs: ITab[] = [
    {
      id: '/',
      label: TabsDisplayNames.BallTracking,
      onClick: (): void => uiStore.setActiveTab(TabsNames.BallTracking),
    },
    {
      id: 'accepted',
      label: TabsDisplayNames.PlayerTracking,
      onClick: (): void => uiStore.setActiveTab(TabsNames.PlayerTracking),
    },
  ];

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setActiveTab(newValue);
  };

  return (
    <StyledTabs value={activeTab} onChange={handleChange} indicatorColor='secondary'>
      {tabs.map((tab: ITab) => {
        if (!isPlayerTrackingEnabled && tab.label === TabsDisplayNames.PlayerTracking) {
          return;
        }
        return (
          <StyledTab
            key={tab.id}
            label={
              <TabLabel
                isVerified={tab.label === TabsDisplayNames.PlayerTracking ? isPlayerTrackingVerified : isVerified}
                label={tab.label}
              />
            }
            onClick={tab.onClick}
          />
        );
      })}
    </StyledTabs>
  );
};

export default Tabs;
